import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

class Animation {
  constructor() {
    gsap.registerPlugin(ScrollTrigger)
  }

  initShopBoxes() {
    gsap.utils.toArray('[data-animation-trigger]').forEach(animationTrigger => {
      const animationBlock = animationTrigger.querySelector('[data-animation-block]')
      const matchQuery = animationTrigger.dataset.animationTriggerMatchQuery || null;

      if (!animationBlock || !animationBlock.checkVisibility()) return

      const specificParamsStr = animationBlock.dataset.animationBlock

      const $createTrigger = function () {
        if (animationTrigger.dataset.animationTrigger === 'vertical') {
          const defaultParams = {
            trigger: animationTrigger,
            pin: animationTrigger,
            scrub: 0.5,
            animation: 'tween',
          }

          let specificParams = {}

          if (specificParamsStr) {
            specificParams = JSON.parse(specificParamsStr)
          }

          gsap.to(animationBlock, {
            y: 702 - animationBlock.clientHeight,
            scrollTrigger: {...defaultParams, ...specificParams}
          })
        } else {
          const defaultParams = {
            trigger: animationTrigger,
            pin: true,
            scrub: 0.5,
            animation: 'tween',
            end: animationBlock.offsetWidth,
          }

          let specificParams = {}

          if (specificParamsStr) {
            specificParams = JSON.parse(specificParamsStr)
          }

          gsap.to(animationBlock, {
            x: -animationBlock.clientWidth,
            scrollTrigger: {...defaultParams, ...specificParams}
          })
        }
      }

      if(matchQuery) {
        const mm = gsap.matchMedia();
        mm.add(matchQuery, () => {
          $createTrigger();
        });
      }
      else {
        $createTrigger();
      }
    })
  }

  init() {
    this.initShopBoxes()
  }
}

export {Animation}
